import { Card } from '@/components/ui/card';
import { useCampaigns } from '@/hooks/useCampaigns';
import { format } from 'date-fns';
import { motion } from 'framer-motion';

export const NextPostCard = () => {
  const { data: campaigns } = useCampaigns();
  // Get all posts from all campaigns

  if (!campaigns) {
    return null;
  }

  const allPosts = campaigns.flatMap((campaign) => campaign.posts);

  // Find the next post (first post that's after current date)
  const now = new Date();
  const nextPost = allPosts
    .filter((post) => {
      const postDate = new Date(post.dateTime);

      return postDate > now;
    })
    .sort((a, b) => {
      const dateA = new Date(a.dateTime);
      const dateB = new Date(b.dateTime);

      return dateA.getTime() - dateB.getTime();
    })[0];

  if (!nextPost) {
    return null;
  }

  const campaign = campaigns.find((c) => c.id === nextPost.campaignId);
  const postDate = new Date(nextPost.dateTime);

  return (
    <Card className="p-5 h-max w-full">
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h2 className="text-lg font-semibold">Upcoming Post</h2>
        </motion.div>
        <div className="flex flex-col gap-2">
          <p className="text-2xl font-bold">{format(postDate, 'MMM d')}</p>
          <p className="text-sm text-muted-foreground">
            {format(postDate, "EEEE 'at' h:mm a")}
          </p>
          {campaign && (
            <p className="text-sm text-muted-foreground">
              Campaign: {campaign.name}
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};
